import React from "react"
import { useSearchParams } from "react-router-dom"
import { getParamsArray, getParamsString } from "."

import Stack from "@mui/material/Stack"
import { TextButton } from "../../element-components"

const DataFilter = ({ filterObjects, getData }) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const selectableFilters = filterObjects.filter(({ idFilter, hiddenFilter }) => !(idFilter || hiddenFilter))

  function updateSearchParams(filterKey, filter) {
    const paramsArray = getParamsArray(filterObjects, searchParams)

    const updatedParams = paramsArray.reduce((updatedParams, paramsObject) => {
      const { paramKey } = paramsObject

      if (filterKey === paramKey) updatedParams.push({ paramKey, param: filter })
      else updatedParams.push(paramsObject)

      return updatedParams
    }, [])

    const paramsString = getParamsString(updatedParams)
    setSearchParams(paramsString, { replace: true })
    getData(paramsString)
  }

  return (
    <Stack sx={{ marginTop: "25px", justifyContent: "center", alignItems: "center" }}>
      {selectableFilters.map((filterObject, index) => {
        const { filterKey, filterOptions } = filterObject

        let marginTop = "10px"
        if (index === 0) marginTop = "0px"

        return (
          <Stack direction="row" spacing="20px" style={{ justifyContent: "center", alignItems: "center", marginTop: marginTop }}>
            {filterOptions.map((filter) => {
              const currentFilter = searchParams.get(filterKey)
              const isSelected = filter.value === currentFilter

              return (
                <Stack sx={{ flexShrink: 0 }}>
                  <TextButton
                    text={filter.display}
                    variant="t5"
                    color={isSelected ? "tertiary" : "primary"}
                    onClick={() => updateSearchParams(filterKey, filter.value)}
                    innerMargin="0px"
                  />
                </Stack>
              )
            })}
          </Stack>
        )
      })}
    </Stack>
  )
}

export default DataFilter